module.exports = __webpack_public_path__ + "static/media/shopping-cart.b35fd70e.svg";